import Vue from 'vue';

Vue.filter('capitalize', (value) => value.charAt(0).toUpperCase() + value.slice(1));
Vue.filter('substring', (value, limit) => value.substring(0, limit));
Vue.filter('price', (value) => value.toFixed(2).replace('.', ','));
Vue.filter('trim', (value) => value.trim());
Vue.filter('uppercase', (value) => value.toUpperCase());
Vue.filter('lowercase', (value) => value.toLowerCase());

Vue.directive('focus', {
	inserted(el) {
		const tagName = el.tagName.toLowerCase();

		if (tagName !== 'input') {
			setTimeout(() => {
				const inputs = el.getElementsByTagName('input');
				if (inputs.length > 0) el.getElementsByTagName('input')[0].focus();
			}, 1000);
		} else {
			setTimeout(() => {
				el.focus();
			}, 1000);
		}
	}
});
